<template>
  <div v-if="show">
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <div class="margin-left-10 margin-right-10">
      <weex-text v-html="uploadInstructions"></weex-text>
    </div>

    <file-attach-button
      class="horizontal_center margin_top_40"
      size="medium"
      file-attach-button-id="upload_cancelled_cheque"
      text="Upload Cancelled Cheque"
      :attach-image-des-src="documentAttachImage"
      :enabled-text-style="attachFileButtonTextStyle"
      :enabled-btn-style="attachFileButtonStyle"
      @filesAttached="onCancelledChequeAttached"
      ></file-attach-button>

    <wxc-button
      text="Next"
      class="margin-top-40 margin-bottom-20 horizontal_center"
      type="blue"
      @wxcButtonClicked="onSubmit"
      ></wxc-button>

  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import Loading from "./Loading";
  import ErrorAlertItem from "./ErrorAlertItem";
  import FileAttachButton from "./FileAttachButton";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import DataSource from "../../data/DataSource";
  import { Constants } from "../Constants";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
  import { EntityType } from "../../utils/EntityType";
  import AlertService from "../core/alert/AlertService";

  const UPLOAD_CANCELLED_CHEQUE = "Please upload Cancelled cheque image.";
  const DOCUMENT_UPLOADED = "Document uploaded successfully";

  export default {
    name: "UploadCancelledChequeItem",
    components: { Loading, ErrorAlertItem, FileAttachButton, WxcButton },
    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      uploadInstruction: {
        type: String,
        required: true,
        default: ""
      },
    },

    data: () => ({
      loading: false,
      errorAlertEvent: false,
      networkError: {},
      cancelledChequeUploaded: false
    }),

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      showError(error) {
        this.loading = false;
        this.networkError = error;
        this.errorAlertEvent = true;
      },

      onCancelledChequeAttached(e) {
        const file = e.files[0];
        this.loading = true;
        DataSource.createDocument(
          EntityType.LOANS,
          LoanScopeDataHolder.getLoanId(),
          Constants.CANCELLED_CHEQUE_NAME,
          Constants.getDescription(Constants.CANCELLED_CHEQUE_NAME),
          Constants.CANCELLED_CHEQUE_DIRECTORY,
          file
        )
          .then(createDocumentRes => {
            this.loading = false;
            if (createDocumentRes.errorOccurred) {
              this.showError(createDocumentRes.data);
            } else {
              this.cancelledChequeUploaded = true;
              this.showToast(DOCUMENT_UPLOADED);
            }
          })
      },

      onSubmit() {
        if(this.checkForValidation()) {
          this.$emit("cancelledChequeUploaded");
        }
      },

      checkForValidation() {
        if (!this.cancelledChequeUploaded) {
          this.showToast(UPLOAD_CANCELLED_CHEQUE);
          return false;
        }

        return true;
      }
    },

    computed: {
      documentAttachImage() {
        return this.cancelledChequeUploaded
          ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
          : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
      },

      attachFileButtonTextStyle() {
        return { color: "#ffffff" };
      },

      attachFileButtonStyle() {
        return {
          "background-color": "#f87246",
          "border-width": "1px",
          "border-style": "solid",
          "border-color": "gray"
        };
      },

      uploadInstructions() {
        const uploadInstructions = this.uploadInstruction ? this.uploadInstruction.split("\n") : [];
        let uploadInstruction = "<html><ul>";
        uploadInstructions.forEach(uploadInstructionItem => {
          uploadInstruction = `${uploadInstruction}<li style="margin-top: 5px; font-size: 16px; color: black;">${uploadInstructionItem}</li>`;
        });
        uploadInstruction = `${uploadInstruction}</ul></html>`;
        return uploadInstruction;
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
